import Box from "@mui/material/Box";
import type { SxProps, Theme } from "@mui/material/styles";

import { gradients } from "../theme";

/**
 * The Energy Pulse — the brand's ambient mark: a violet bloom radiating from a light
 * organic core.
 *
 * Purely decorative, so it is `aria-hidden` and never contains content. Used as a
 * backdrop behind the sign-in screen and as the fallback artwork for an article that
 * has no cover image.
 */
export function EnergyPulse({
  size = 320,
  opacity = 1,
  blur = 0,
  sx,
}: {
  size?: number | string;
  opacity?: number;
  blur?: number;
  sx?: SxProps<Theme>;
}) {
  return (
    <Box
      aria-hidden="true"
      sx={[
        {
          width: size,
          height: size,
          borderRadius: "50%",
          backgroundImage: gradients.pulse,
          opacity,
          filter: blur ? `blur(${blur}px)` : undefined,
          pointerEvents: "none",
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    />
  );
}
